module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"abrir_pers":"Pulsa para abrir la biblioteca de materiales y evaluar un material personalizado de {0}."}}')
  delete Component.options._Ctor
}
